import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=7071eb6a&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=7071eb6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071eb6a",
  null
  
)

export default component.exports